/**
 * screens/admin/adminShared.tsx — small shared pieces for the admin console:
 * AppIcon (accent tile) and a reusable danger ConfirmModal.
 */

import React from 'react';
import { View, Text } from 'react-native';
import { useTheme } from '../../context/themeContext';
import Icon, { IconName } from '../../components/icon';
import { PButton, PModal } from '../../components/platform/controls';
import { FS, R } from '../../utils/platformTokens';

export const AppIcon: React.FC<{ icon: IconName | string; size?: number }> = ({ icon, size = 34 }) => {
  const { theme } = useTheme();
  const c = theme.colors;
  return (
    <View style={{ width: size, height: size, borderRadius: R.r2, backgroundColor: c.accentSoft, alignItems: 'center', justifyContent: 'center' }}>
      <Icon name={icon} size={size * 0.5} color={c.accent} />
    </View>
  );
};

export const ConfirmModal: React.FC<{
  open: boolean; onClose: () => void; onConfirm: () => void; title: string; body: string; confirmLabel: string;
}> = ({ open, onClose, onConfirm, title, body, confirmLabel }) => {
  const { theme } = useTheme();
  return (
    <PModal open={open} onClose={onClose} size="sm" title={title}
      footer={<>
        <PButton kind="ghost" onPress={onClose}>Cancel</PButton>
        <PButton kind="danger" onPress={onConfirm}>{confirmLabel}</PButton>
      </>}>
      <Text style={{ fontSize: FS.md, color: theme.colors.ink2, lineHeight: 20 }}>{body}</Text>
    </PModal>
  );
};
